
export default {
  currentTime: 0,
  timeouts: {},
  currentLevel: 55,
  currentSupply: 0,
  currentRate: 0.07,
  currentDemand: 360,
  minutesOnAlert: 0,
  newAlert: true,
  newIssue: true,
  minutesOnWarning: 0,
  totalPower: 0,
  totalCost: 0,
  totalPowerCost: 0,
  analyticsCost: 0,
  analyticsPumps: 0,
  analyticsSaves: 0,
  analyticsMissed: 0,
  repairCost: 0,
  incidentCost: 0,
  pumpIncidents: 0,
  pumpIssues: 0,
  pumpIncidentsAvoided: 0,
  townIncidents: 0,
  townIssues: 0,
  customerSatisfaction: 1,
  customerSatisfactionExpected: 1,
  simulationInterval: 200,
  minutesByInterval: 2,
  gpmDamageProbability: 0.5,
  randomPumpFailProbability: 0.001,
  randomPumpFailGPM: 250,
  randomPumpDamageProbability: 0.5,
  randomPumpDamageGPM: 250,
  randomPumpFails: 0,
  randomPumpFailTime: 0,
  randomFailAfterHours: 6,
  pumpDamageRepairLevel: 400,
  maxRandomPumpFails: 2,
  randomFailIntervalHours: 4,
  towerOverflowTimeout: 120, // elapsed minutes to fail after overflow
  towerEmptyTimeout: 120, // elapsed minutes to fail after empty tower
  previousFailedPump: -1,
  lastPumpFailTimestamp: 0,
  minEventTimeSeconds: 20,
  running: false,
  debug: false,
  challengeFailed: false,
  towerOverflow: false,
  currentEvent: null,
  pumps: [
    {
      number: 1,
      active: true,
      state: 'Running',
      power: 4.0,
      gpm: 320,
      askRepair: false,
      repair: 0,
      analytics: false,
      preventFail: false,
      lastRepair: 0
    },
    {
      number: 2,
      active: false,
      state: 'Stopped',
      power: 4.0,
      gpm: 320,
      askRepair: false,
      repair: 0,
      analytics: false,
      preventFail: false,
      lastRepair: 0
    },
    {
      number: 3,
      active: false,
      state: 'Stopped',
      power: 4.0,
      gpm: 320,
      askRepair: false,
      repair: 0,
      analytics: false,
      preventFail: false,
      lastRepair: 0
    }
  ],
  events: []
}
